import React, { useEffect, useMemo } from 'react';
import { KoForm, KoFormBuilder } from 'packages';
import styles from '../../template.module.scss';
import commonProperties from './commonProperties';
import { typeSpecificProperties } from './typeSpecificProperties';

export default function FieldPropertiesEditor({ form, currentItem, currentProperties, handleSaveProperties }) {

  const fieldMeta = useMemo(() => {
    const type = currentItem?.type;
    const specificProps = typeSpecificProperties[type] || [];
    const skipCommonPropsFor = ['heading','subHeading', 'divider', 'spacer'];
    const skipmandatory = ['heading', 'subHeading','divider', 'spacer', 'table', 'invoicetable', 'fieldset'];

    const skipPlaceholder = ['heading', 'subHeading', 'rating','slider', 'divider', 'spacer', 'table', 'time', 'yesno', 'color', 'signature'];
    let fields = skipCommonPropsFor.includes(type)
      ? [...specificProps]
      : [...commonProperties, ...specificProps];

    if (!fields.some(f => f.key === 'id')) {
      fields.push({
        key: 'id',
        placeholder: 'Enter key',
        label: 'Field ID',
        colSpan: 3,
        disabled: true
      });
    }
    if (skipPlaceholder.includes(type)) {
      fields = fields.filter(f => f.key !== 'placeholder');
    }
    if (skipmandatory.includes(type)) {
      fields = fields.filter(f => f.key !== 'required');
    }

    return {
      columns: 3,
      formItemLayout: null,
      initialValues: currentProperties,
      colon: true,
      fields
    };
  }, [currentItem, currentProperties]);


  useEffect(() => {
    if (currentProperties) {
      form.setFieldsValue(currentProperties);
    }
  }, [currentProperties]);

  const onValuesChange = (_, allValues) => {
    handleSaveProperties(allValues);
  };

  if (!currentItem) return null;

  return (
    <div className={styles.propertyWrapper}>
      <KoForm
        form={form}
        layout="vertical"
        onFinish={handleSaveProperties}
        onValuesChange={onValuesChange}
      >
        <KoFormBuilder form={form} meta={fieldMeta} />
      </KoForm>
    </div>
  );
}
